var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWideArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 66,
  height: 15,
  fill: "none",
  viewBox: "0 0 66 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M30.294 14.1a10 10 0 0 0 5.882 0l27.905-8.586a2.5 2.5 0 0 0-1.47-4.779L36.176 8.87a10 10 0 0 1-5.882 0L3.86.735a2.5 2.5 0 0 0-1.47 4.78z",
  clipRule: "evenodd",
  opacity: 0.8
})));
export { SvgWideArrowDown as ReactComponent };